// extracted by mini-css-extract-plugin
export var footer = "_oo-5";
export var fulfillmentInput = "_oo-0";
export var shipDateInput = "_oo-1";
export var shipmentModal = "_oo-2";
export var shipmentModalContent = "_oo-3";
export var tableContainer = "_oo-4";